/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArtifacts = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 8V2H6v8H2v12h12v-4h8V8h-5zm-5 12H4v-8h8v8zM8 10V4h7v8h-1v-2H8zm9 3v-3h3v6h-6v-2h3"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgArtifacts as Artifacts };
